<body>
  <div class="heading1">
    <h1>Launching Soon</h1>
  </div>
  <div class="container-fluid">
    <div class="row d-flex justify-content-between all-div">
      <div class="col-lg-4 contents">
        <div class="bg-title">
          <div class="title">
            NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
          </div>
          <div class="subtitle"></div>
        </div>
        <p>
          Are you looking for a revolutionary idea that can change your life? If
          yes, then we both think alike. At ONPASSIVE, we are constantly cooking
          up new ideas and innovations to help millions reach their dreams. With
          a rock solid foundation of artificial intelligence, you can build your
          business, enhance your team and aim towards success. Crossing things
          off your bucket list is such a pleasant feeling, isn't it? Well, if
          you haven't experienced it yet, it is high time that you start now.
        </p>
        <a
          href="/registration/user?reg={{ userId }}"
          name="regform"
          target="_blank"
          rel="noopener"
          class="button pulse"
        >
          Become a Founder
        </a>
      </div>
      <div class="col-lg-5">
        <!--  video starts -->
        <div class="video">
          <div class="video_box">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
              width="100%"
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <!--  video ends -->
      </div>
    </div>
  </div>
  <div
    class="robort-hand"
    data-aos="fade-left"
    data-aos-delay="200"
    data-aos-duration="1500"
  >
    <img
      src="{{ onPassiveBaseUrl }}onpassive(nov7)/images/robot_hand.png"
      alt="robot"
      width="100%"
    />
  </div>
  <div class="phone">
    <img
      src="{{ onPassiveBaseUrl }}onpassive(nov7)/images/mobile.png"
      alt="mobile"
      width="100%"
    />
  </div>
  <div class="bulb">
    <img
      src="{{ onPassiveBaseUrl }}onpassive(nov7)/images/light.png"
      alt="light"
      width="100%"
    />
    <div class="logo">
      <img src="{{ onPassiveBaseUrl }}onpassive(nov7)/images/logo.png" alt="logo"/>
    </div>
  </div>
</body>
